
import CheckIcon from '@mui/icons-material/Check'
import { Badge, IconButton, Tooltip, useTheme } from '@mui/material'
import { GridFilterModel } from '@mui/x-data-grid-premium'
import React from 'react'
import { User } from 'types'

const FilterMyDataButton = ({
  profile,
  icon,
  filterModel,
  onClick,
  label,
}: {
  // Toolbars pass `activeUser.user.profile` which is the Slack profile
  // (has `real_name`), not the canonical User. Intersect so the field is typed.
  profile?: User & { real_name?: string }
  icon: React.ReactNode
  filterModel: GridFilterModel
  onClick: () => void
  label: string
}) => {
  const theme = useTheme()
  // const isFilterActive =
  //   filterModel && Array.isArray(filterModel.quickFilterValues) && filterModel.quickFilterValues.length > 0
  // Toolbars (GlobalGridToolbar / BoardsGridToolbar / CustomGridToolbar /
  // MetricsToolbar / OptimizationToolbar) all set quickFilterValues to the
  // user's `real_name`, so we have to compare against the same field.
  const user_name = profile?.real_name
  const isOwnerFilterActive =
    filterModel &&
    profile &&
    Array.isArray(filterModel.quickFilterValues) &&
    filterModel.quickFilterValues?.includes(user_name)
  return (
    <Tooltip title={label}>
      <IconButton
        sx={{
          borderRadius: '0px',
          cursor: 'pointer',
        }}
        onClick={onClick}
      >
        <Badge
          badgeContent={
            <CheckIcon
              sx={{
                fontSize: '18px',
                color: isOwnerFilterActive ? theme.palette.text.success : theme.palette.text.secondary,
              }}
            />
          }
        >
          {icon}
        </Badge>
      </IconButton>
    </Tooltip>
  )
}

export default FilterMyDataButton
